import AssignmentReturnOutlinedIcon from '@mui/icons-material/AssignmentReturnOutlined';
import BuildTwoToneIcon from '@mui/icons-material/BuildTwoTone';
import CloudSyncTwoToneIcon from '@mui/icons-material/CloudSyncTwoTone';
import DashboardCustomizeTwoToneIcon from '@mui/icons-material/DashboardCustomizeTwoTone';
import DashboardTwoToneIcon from '@mui/icons-material/DashboardTwoTone';
import FactCheckTwoToneIcon from '@mui/icons-material/FactCheckTwoTone';
import GpsFixedTwoToneIcon from '@mui/icons-material/GpsFixedTwoTone';
import InventoryIcon from '@mui/icons-material/Inventory';
import MemoryTwoToneIcon from '@mui/icons-material/MemoryTwoTone';
import PeopleIcon from '@mui/icons-material/People';
import ReportIcon from '@mui/icons-material/Report';
import SettingsTwoToneIcon from '@mui/icons-material/SettingsTwoTone';
import registerModuleWithMenu from 'src/config/AccessControl/registerModuleWithMenu';
import {
  DashboardModule,
  DeploymentDashboardModule,
  OrderDashboardModule,
  ServiceDashboardModule
} from 'src/content/dashboards/module';
import {
  StationDashboardModule,
  JobWiseReportModule,
  UserWiseReportModule
} from 'src/content/reports/SessionReport/module';
import { DepartmentViewModule } from 'src/content/management/Department/module';
import { DeviceViewModule } from 'src/content/management/Devices/module';
import { FirmwareVariantViewModule } from 'src/content/management/FirmwareVarient/module';
import { FirmwareVersionViewModule } from 'src/content/management/FirmwareVersions/module';
import { FirmwareViewModule } from 'src/content/management/Firmwares/module';
import { FirmwareLifecycleViewModule } from 'src/content/management/FirmwareLifecycles/module';
import { InventoryCachingViewModule } from 'src/content/management/InventoryCaching/module';
import { ItemViewModule } from 'src/content/management/Items/module';
import { MaterialPlanningModule } from 'src/content/management/MaterialPlanning/module';
import { OTAViewModule } from 'src/content/management/OTA/module';
import { OrderViewModule } from 'src/content/management/Order/module';
import { OrganisationViewModule } from 'src/content/management/Organisation/module';
import { PDILogsViewModule } from 'src/content/management/PDILogs/module';
import { ProductionOrderViewModule } from 'src/content/management/ProductionOrders/module';
import { ReturnViewModule } from 'src/content/management/Return/module';
import { RoleViewModule } from 'src/content/management/Role/module';
import { ServiceViewModule } from 'src/content/management/Service/module';
import { UserViewModule } from 'src/content/management/Users/module';
// import { ProductViewModule } from 'src/content/management/Products/module';
import { BomViewModule } from 'src/content/management/BOM/module';
import { ItemGroupViewModule } from 'src/content/management/ItemGroup/module';
import { TagViewModule } from 'src/content/management/Tags/module';
import { VendorOrderViewModule } from 'src/content/management/VendorOrders/module';
import { DeviceAlertsViewModule } from 'src/content/reports/DeviceAlerts/module';
import { DeviceIssueListingViewModule } from 'src/content/reports/DeviceIssueListing/module';
// import { ProcessViewModule } from 'src/content/management/Process/module';
import { ProcessViewModule } from 'src/content/management/Process/module';
import { QRCodeGenerationViewModule } from 'src/content/management/QRCodeGeneration/module';
import { InventoryTransactionViewModule } from 'src/content/reports/InventoryTransaction/module';
import { InventoryTransactionSummaryViewModule } from 'src/content/reports/InventoryTransactionSummary/module';
import { ProductionOrderSummaryViewModule } from 'src/content/reports/ProductionOrderSummary/module';
import { QrcodesReportViewModule } from 'src/content/reports/QrcodesReport/module';
import { POReportViewModule } from 'src/content/reports/POReport/module';
import { PDISummaryViewModule } from 'src/content/reports/PDISummary/module';
import { ProcessLogSummaryViewModule } from 'src/content/reports/ProcessLogSummary/module';
import { ProcessLogOrderSummaryViewModule } from 'src/content/reports/ProcessLogOrderSummary/module';
import { AlertViewModule } from 'src/content/management/Alert/module';

const sortAlphaAsc = (a, b) => a.name.localeCompare(b.name);

const menuItems = [
  {
    heading: '',
    id: 'root',
    path: '',
    items: [
      registerModuleWithMenu(DashboardModule, {
        icon: DashboardTwoToneIcon
      }),
      {
        name: 'Other Dashboards',
        icon: DashboardCustomizeTwoToneIcon,
        id: 'root',
        path: '/dashboards',
        items: [
          registerModuleWithMenu(DeploymentDashboardModule),
          registerModuleWithMenu(OrderDashboardModule),
          registerModuleWithMenu(ServiceDashboardModule)
        ].sort(sortAlphaAsc)
      },
      registerModuleWithMenu(DeviceViewModule, {
        icon: GpsFixedTwoToneIcon
      }),
      {
        name: 'Orders',
        icon: SettingsTwoToneIcon,
        id: 'root',
        path: '/orders',
        items: [
          registerModuleWithMenu(OrderViewModule),
          registerModuleWithMenu(ProductionOrderViewModule),
          registerModuleWithMenu(VendorOrderViewModule)
        ].sort(sortAlphaAsc)
      },
      registerModuleWithMenu(PDILogsViewModule, {
        icon: FactCheckTwoToneIcon
      }),
      {
        name: 'Firmware Management',
        icon: MemoryTwoToneIcon,
        id: 'root',
        path: '/firmware-management',
        items: [
          registerModuleWithMenu(FirmwareViewModule),
          registerModuleWithMenu(FirmwareVariantViewModule),
          registerModuleWithMenu(FirmwareVersionViewModule),
          registerModuleWithMenu(FirmwareLifecycleViewModule)
        ].sort(sortAlphaAsc)
      },
      {
        name: 'Inventory Management',
        icon: InventoryIcon,
        id: 'root',
        path: '/inventory-management',
        items: [
          registerModuleWithMenu(InventoryCachingViewModule),
          registerModuleWithMenu(MaterialPlanningModule),
          registerModuleWithMenu(ItemGroupViewModule),
          registerModuleWithMenu(ItemViewModule),
          registerModuleWithMenu(BomViewModule),
          registerModuleWithMenu(ProcessViewModule),
          registerModuleWithMenu(QRCodeGenerationViewModule)
        ].sort(sortAlphaAsc)
      },
      registerModuleWithMenu(DepartmentViewModule, {
        icon: PeopleIcon,
      }),
      registerModuleWithMenu(OTAViewModule, {
        icon: CloudSyncTwoToneIcon
      }),
      registerModuleWithMenu(ServiceViewModule, {
        icon: BuildTwoToneIcon
      }),
      registerModuleWithMenu(ReturnViewModule, {
        icon: AssignmentReturnOutlinedIcon
      }),
      registerModuleWithMenu(AlertViewModule, {
        icon: SettingsTwoToneIcon
      }),
      {
        name: 'Report',
        icon: ReportIcon,
        id: 'root',
        path: '/reports',
        items: [
          {
            name: 'Production Reports',
            id: 'root',
            path: '/reports/session-report',
            items: [
              registerModuleWithMenu(StationDashboardModule),
              registerModuleWithMenu(JobWiseReportModule),
              registerModuleWithMenu(UserWiseReportModule)
            ].sort(sortAlphaAsc)
          },
          registerModuleWithMenu(ProductionOrderSummaryViewModule),
          registerModuleWithMenu(InventoryTransactionViewModule),
          registerModuleWithMenu(InventoryTransactionSummaryViewModule),
          registerModuleWithMenu(DeviceIssueListingViewModule),
          registerModuleWithMenu(DeviceAlertsViewModule),
          registerModuleWithMenu(QrcodesReportViewModule),
          registerModuleWithMenu(POReportViewModule),
          registerModuleWithMenu(PDISummaryViewModule),
          registerModuleWithMenu(ProcessLogSummaryViewModule),
          registerModuleWithMenu(ProcessLogOrderSummaryViewModule)
        ].sort(sortAlphaAsc)
      },
      {
        name: 'Management',
        icon: SettingsTwoToneIcon,
        id: 'root',
        path: '/management',
        items: [
          registerModuleWithMenu(UserViewModule),
          registerModuleWithMenu(RoleViewModule),
          registerModuleWithMenu(OrganisationViewModule),
          registerModuleWithMenu(TagViewModule)
        ].sort(sortAlphaAsc)
      }
    ]
  }
];

const filterSidebar = (items, filter) => {
  return (
    items
      // eslint-disable-next-line array-callback-return, consistent-return
      .map((item) => {
        if (item.items) {
          const filteredChildren = filterSidebar(item.items, filter);
          if (filteredChildren.length === 0) return null;
          return { ...item, items: filteredChildren };
        }
        if (filter(item.id)) return item;
      })
      .filter(Boolean)
  );
};

export { filterSidebar, menuItems };

// export default menuItems;
